<template>
    <div class="login">
        <img src="~ThemePath/images/logo2.png/" />
        <p>{{ handleTextAppVersion() }}</p>
        <h2 class="login__title">{{ getTranslatedText('login terminal') }}</h2>
        <FormCommon
            :formItem="formItem"
            :dataForm="dataForm"
            nameFunction="on-change-value"
        />
        <div class="login__box-button">
            <ButtonCommon
                className="w100"
                :isNoHover="true"
                :isLoading="isLoadingButton"
                value="login"
                nameFunction="on-click-login"
            />
        </div>
    </div>
</template>
<script>
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import languageMixins from '@/mixins/language/language-mixins'
import FormCommon from '@/components/common/form/index.vue'
import ButtonCommon from '@/components/common/button/index.vue'
import EventBus from '@/utils/EventBus'
import AuthService from '@/services/auth.service'
import {isArrayEmpty, isStrEmpty, parseSetting} from '@/utils/utils'
import { version } from '../../../package.json'
import {setToken, setTokenV3, setUserInfo} from '@/services/axios'
import store from "@/store";
const ACCOUNT = process.env.VUE_APP_ACCOUNT
const IS_DEBUG = process.env.VUE_APP_IS_DEBUG
const IS_DEV = process.env.VUE_APP_IS_DEV

export default {
    mixins: [themeMixins, languageMixins],
    components: { FormCommon, ButtonCommon },
    data() {
        return {
            isLoadingButton: false,
            appVersion: version,
            ACCOUNT: ACCOUNT,
            IS_DEBUG: IS_DEBUG,
            formItem: [
                {
                    label: 'terminal',
                    name: 'terminal',
                    type: 'text',
                    required: true,
                },
                {
                    label: 'terminal pin',
                    name: 'terminalPin',
                    type: 'password',
                    required: true,
                },
            ],
            dataForm: {
                terminal: '',
                terminalPin: '',
            },
        }
    },
    created() {
        EventBus.$on('on-change-value', (value) => {
            this.changeValueLogin(value)
        })
        EventBus.$on('on-click-login', () => {
            this.handleLogin()
        })
    },

    destroyed() {
        EventBus.$off('on-change-value')
        EventBus.$off('on-click-login')
    },

    computed: {
        displayVersion() {
            return this.$store.getters.mappedAppVersionName || version
        },
    },

    methods: {
        handleTextAppVersion() {
            let v = this.$t(`version ${this.displayVersion}`)
            if(IS_DEV && IS_DEV != '') v = v + " - DEV";
            return v;
        },
        changeValueLogin(item) {
            let { event, name } = item
            this.dataForm[name] = event.target.value
        },

        async handleLogin() {
            try {
                this.isLoadingButton = true
                const param = {
                    terminal_id: this.dataForm.terminal,
                    terminal_pin: this.dataForm.terminalPin,
                    login_method: 'terminal',
                }
                // reset warining of location permission
                localStorage.removeItem('location_permission_waring_count')
                const res = await AuthService.login(param)
                if (res.status === '200') {
                      this.$store.state.tokenV3 = res.data.gamev3.token
                      setTokenV3(res.data.gamev3.token)
                      setToken(res.data.token)
                      const paramInfo = { ...res.data }
                      paramInfo.config = parseSetting(AuthService.readSettingFromEnv())
                      delete paramInfo.token
                      setUserInfo(paramInfo)
                      await this.$store.dispatch('handleUserInfo', paramInfo)
                      this.$router.go('/')
                  } else {
                      let message = ''
                      !isArrayEmpty(res.errors)
                          ? res.errors.forEach((element) => {
                                message += element.message
                            })
                          : (message = res.message)
                      const param = {
                          text: message,
                          type: 'error',
                      }
                      EventBus.$emit('show-notications', param)
                  }
                this.$store.state.isShowExtra7Boost = res.data?.details?.enabled_game_slugs?.indexOf('extra7-boost') !== -1;
                this.$store.state.isShow645 = res.data?.details?.enabled_game_slugs?.indexOf('lotto-6-45') !== -1;
                this.$store.state.isShowSports = res.data?.details?.enabled_game_slugs?.indexOf('bitville-sports') !== -1;
                this.$store.state.reprintCountToShowCancel = res.data?.details?.reprint_count_to_show_cancel ? parseInt(res.data?.details?.reprint_count_to_show_cancel) : null;
                this.$store.state.showCancelationInPos = res.data?.details?.show_cancelation_in_fe_pos ?? false;
                this.$store.state.milisecondsToForceFinishPrinting = res.data?.details?.miliseconds_to_force_finish_printing ? parseInt(res.data?.details?.miliseconds_to_force_finish_printing) : null;
                this.$store.state.autoCancelUnprintedCountdownSeconds = res.data?.details?.auto_cancel_unprinted_countdown_seconds
                    ? parseInt(res.data.details.auto_cancel_unprinted_countdown_seconds, 10)
                    : null;
                this.$store.state.usersBypassPrintingCheck = res.data?.details?.users_bypass_printing_check ?? '';
                this.$store.state.usersSimulatePrintError = res.data?.details?.users_simulate_print_error ?? '';
                this.$store.state.printSimulateMode = res.data?.details?.print_simulate_mode ?? 'always-error';
                this.$store.state.autoCancelUnprintedCountdownSeconds = res.data?.details?.auto_cancel_unprinted_countdown_seconds
                    ? parseInt(res.data.details.auto_cancel_unprinted_countdown_seconds, 10)
                    : null;
                this.$store.state.maxAutoReprintAttempts = res.data?.details?.max_auto_reprint_attempts != null
                    ? parseInt(res.data.details.max_auto_reprint_attempts, 10)
                    : 1;
                this.$store.state.usersNewReprintDialog = res.data?.details?.users_new_reprint_dialog ?? '';
                this.$store.state.usingReprintDialog = res.data?.details?.using_new_reprint_dialog ?? false;
                this.$store.state.networkTimeoutSeconds = res.data?.details?.network_timeout_seconds ? parseInt(res.data?.details?.network_timeout_seconds) : null;
                // todo: storing store here make no sense since state is reseted after move to home
                this.isLoadingButton = false
            } catch (error) {
                this.isLoadingButton = false
                const param = {
                  text: (error?.message ?? error),
                  type: 'error',
                }
                
                if(!error.response && isStrEmpty(error?.message)) {
                    param['text'] = this.getTranslatedText('Request timeout. Please check your network connection.')
                }

                EventBus.$emit('show-notications', param)
            }
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/login/_index.scss';
</style>
